"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreTheme = exports.coreBorders = exports.coreBreakpoints = exports.coreLighthouseTermBorderAttributes = exports.coreHorizontalRuleBorderAttributes = exports.coreBuyBoxButtonBorderAttributes = exports.coreBuyBoxBorderAttributes = exports.coreSpacings = exports.coreBaseFont = exports.coreLighthouseTerm = exports.coreBuyBoxButtonPalette = exports.coreFontPalette = void 0;
exports.coreFontPalette = {
    primary: '#0F1111',
    secondary: '#555555',
    instantly: '#009900',
    price: '#b12704',
    link: '#007185',
    linkHover: '#c45500'
};
exports.coreBuyBoxButtonPalette = {
    foreground: '#111',
    background: 'linear-gradient(to bottom, #f7dfa5, #f0c14b)',
    backgroundHover: 'linear-gradient(to bottom, #f5d78e, #eeb933)'
};
exports.coreLighthouseTerm = {
    foreground: '#111111',
    background: '#D7E8EA'
};
exports.coreBaseFont = {
    fontFamily: '"Amazon Ember", Arial, sans-serif',
    fontStyle: 'normal',
    fontSize: '13px',
    lineHeight: '19px'
};
exports.coreSpacings = {
    xs: '5px',
    sm: '10px',
    md: '20px',
    lg: '40px',
    xl: '60px',
    xxl: '80px',
    xxxl: '100px'
};
exports.coreBuyBoxBorderAttributes = {
    border: '1px #ddd solid',
    borderRadius: '4px'
};
exports.coreBuyBoxButtonBorderAttributes = {
    border: '1px solid',
    borderColor: '#a88734 #9c7e31 #846a29',
    borderRadius: '2px'
};
exports.coreHorizontalRuleBorderAttributes = {
    borderTop: '1px solid #e7e7e7'
};
exports.coreLighthouseTermBorderAttributes = {
    borderBottom: 'solid 1px #969696'
};
exports.coreBreakpoints = {
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px'
};
exports.coreBorders = {
    buyBox: exports.coreBuyBoxBorderAttributes,
    buyBoxButton: exports.coreBuyBoxButtonBorderAttributes,
    horizontalRule: exports.coreHorizontalRuleBorderAttributes,
    lightHouseTerm: exports.coreLighthouseTermBorderAttributes
};
exports.coreTheme = {
    palettes: {
        font: exports.coreFontPalette,
        buyBoxButton: exports.coreBuyBoxButtonPalette,
        lighthouseTerm: exports.coreLighthouseTerm
    },
    typography: {
        base: exports.coreBaseFont
    },
    spacings: exports.coreSpacings,
    borders: exports.coreBorders,
    breakpoints: exports.coreBreakpoints
};
__exportStar(require("./monera"), exports);
__exportStar(require("./monera-mobile"), exports);
__exportStar(require("./types"), exports);
